<template>
  <el-button type="text" @click="jump">{{
    scope.row[tableData.bind]
  }}</el-button>
</template>

<script>
export default {
  name: 'detailBtn',
  props: {
    tableData: Object,
    scope: Object
  },
  methods: {
    jump() {
      window.open(`//${this.scope.row[(this.tableData.bind)]}`);
    }
  }
};
</script>

<style scoped></style>
